import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Shield, Lock, Server } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const partners = ["OpenFisca", "FranceConnect", "API Gouv", "Service-Public.fr"];

export const TechnologySection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const { isDark } = useTheme();

  return (
    <section 
      id="technology"
      className={`section-apple px-6 ${isDark ? 'bg-[#0a0a0a]' : 'bg-white'}`}
      data-testid="technology-section"
    >
      <div className="max-w-[980px] mx-auto">
        {/* Headline */}
        <motion.div
          ref={ref}
          className="text-center mb-16"
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className={`text-[40px] sm:text-[48px] md:text-[56px] font-semibold tracking-[-0.03em] leading-[1.1] mb-6 ${
            isDark ? 'text-[#f5f5f7]' : 'text-[#1d1d1f]'
          }`}>
            Sources <span className="text-[#81d8d0]">officielles.</span>
          </h2>
          <p className={`text-[19px] tracking-[-0.016em] max-w-[600px] mx-auto ${
            isDark ? 'text-[#86868b]' : 'text-[#6e6e73]'
          }`}>
            Basé sur des sources officielles et barèmes publics : Service-Public, OpenFisca, CAF et impots.gouv.fr selon les cas.
          </p>
        </motion.div>

        {/* Partners */}
        <motion.div
          className="flex flex-wrap justify-center gap-8 mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {partners.map((partner, index) => (
            <span 
              key={index}
              className={`text-[15px] font-medium tracking-[-0.01em] ${
                isDark ? 'text-[#6e6e73]' : 'text-[#86868b]'
              }`}
            >
              {partner}
            </span>
          ))}
        </motion.div>

        {/* Security badges - Apple minimal */}
        <motion.div
          className="flex flex-wrap justify-center gap-6"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          {[
            { icon: Lock, label: "Chiffrement E2E" },
            { icon: Shield, label: "RGPD" },
            { icon: Server, label: "Hébergé en France" }
          ].map((badge, index) => (
            <div 
              key={index}
              className={`flex items-center gap-2 px-4 py-2 rounded-full ${
                isDark ? 'bg-[#141414]' : 'bg-[#f5f5f7]'
              }`}
            >
              <badge.icon size={14} strokeWidth={1.5} className="text-[#81d8d0]" />
              <span className={`text-[13px] font-medium ${
                isDark ? 'text-[#f5f5f7]' : 'text-[#1d1d1f]'
              }`}>
                {badge.label}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TechnologySection;
